<template>
  <div class="user-info j-user-info" :style="{padding: paddingStyle}">
    <img v-if="showAvatar" :src="avatar || userAvatar" alt="user-avatar" class="avatar" />
    <div class="info-detail">
      <p class="welcome-text">
        <span class="info-user_name">{{userName}}</span>,您好~
      </p>
      <slot>
        <p class="info-tips">請選擇你要儲值的遊戲及角色</p>
      </slot>
    </div>
  </div>
</template>

<script>
import defaultAvatar from '@/assets/avatar.png'
export default {
  name: 'UserInfo',
  props: {
    avatar: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    paddingStyle: {
      type: String,
      default: ''
    },
    showAvatar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      userAvatar: defaultAvatar
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.user-info {
  height: auto;
  display: flex;
  // padding: 0 5px 0 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
  align-items: center;
  background-color: #fff;
  justify-content: flex-start;
  &.no-padding {
    padding: 0;
  }
  .avatar {
    width: 43px;
    height: 43px;
    border-radius: 100%;
    margin-right: 10px;
  }
  .info-detail {
    flex: 1;
  }
  .info-user_name {
    color: #e97d30;
    font-weight: 700;
  }
  p {
    font-size: 16px;
    padding: 0;
    margin: 0;
  }
  .info-tips {
    font-size: 13px;
    color: #6d6d6d;
    text-align: right\9;
  }
}

@media screen and (orientation: landscape) {
  .user-info {
    // height: 50px;
    margin-top: 0;
    margin-bottom: 0;
    // padding: 0 34px;
    line-height: 31px;
    background-color: transparent;
    .avatar {
      display: none;
      // margin-top: 3px;
    }
    .info-detail {
      flex: 1;
      height: 100%;
      display: flex;
      width: 100%\9;
      display: table\9;
      // font-weight: 700;
      color: #6d6d6d;
      align-items: center;
      justify-content: space-between;
      & > p {
        display: table-cell\9;
      }
      .welcome-text {
        width: 30%\9;
      }
      .wallet-balance {
        text-align: right\9;
      }
    }
  }
}
</style>
